import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';
import SectionTitle from '../section-title/section-title.component';

const OrderDetails = ({ items, currency }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <SectionTitle title={t('drawer.refundDrawer.orderDetails')} />
      <Stack spacing={1}>
        {items?.map((item, index) => {
          const { itemName, quantity } = item;
          return (
            <Box display="flex" justifyContent="space-between" key={index}>
              <Typography>
                {itemName} ({quantity})
              </Typography>
              <Typography>
                {formatCurrency(item.itemTotal?.total, currency)}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default OrderDetails;
